import {
  observer,
  useLocation,
  ChevronDown,
  Drawer,
} from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as DocumentNavigationModule from "../../routing/documentNavigation.js";
import * as React from "react";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
import * as DocumentTitlesModule from "../../routing/documentTitles.js";
import * as jsxRuntime from "react/jsx-runtime";
import * as IconModule from "../Icon.jsx";
import * as DocSearchModule from "../DocSearch.jsx";
import { module64828 as tC } from "../../vendor/dependencies.js";
import * as DocNavItemModule from "../DocNavItem.jsx";
import * as LanguageToggleModule from "../LanguageToggle.jsx";
let DocsMobileNav = observer(() => {
  let { pathname: pathname } = useLocation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    i = (0, DocumentNavigationModule.a8)(),
    o = (0, DocumentNavigationModule.f2)(pathname, language),
    [r, l] = (0, React.useState)(false),
    [s, c] = (0, React.useState)(null),
    d = s || o?.key,
    u = (0, React.useMemo)(() => i.find((e) => e.key === d), [i, d]),
    p = (0, React.useMemo)(() => {
      let i = pathname.replace(/^\/docs\/?/u, "") || "",
        n = (0, LocalizedPathsModule.ui)(i)
          .replace(/^\/+/u, "")
          .split("/")
          .filter(Boolean);
      if (0 === n.length) return [];
      let o = [];
      return (
        !(function e(i, a, r) {
          if (a >= n.length) return;
          let l = `/${n[a]}`;
          for (let s of i) {
            if ("spacer" in s) continue;
            let i = s.href ? `${r}${s.href}` : r;
            if (i === l || i === `/${n.slice(0, a + 1).join("/")}`) {
              (o.push(
                (0, DocumentTitlesModule.getLocalizedTitle)(s, language) ||
                  n[a],
              ),
                s.items && e(s.items, a + 1, i));
              return;
            }
          }
          (o.push(n[a]), e([], a + 1, `/${n.slice(0, a + 1).join("/")}`));
        })(DocumentNavigationModule.jj, 0, ""),
        o
      );
    }, [pathname, language]),
    m = (0, React.useCallback)(() => {
      (c(o?.key || null), l(true));
    }, [o?.key]),
    g = (0, React.useCallback)(() => {
      l(false);
    }, []);
  return 0 !== i.length && pathname.includes("/docs/") ? (
    <jsxRuntime.Fragment>
      <div
        className={
          "lg:hidden h-[32px] border-t border-b border-[var(--color-border-warm)] flex items-center px-[16px] w-full shrink-0"
        }
      >
        <div className={"flex gap-[4px] h-full items-center shrink-0 min-w-0"}>
          <button
            type={"button"}
            className={
              "flex items-center gap-[12px] shrink-0 cursor-pointer bg-transparent border-none p-0"
            }
            onClick={m}
            aria-label={"Open navigation"}
          >
            <IconModule.Icon
              icon={"menu"}
              size={16}
              className={"text-[var(--color-text-secondary)]"}
            />
          </button>
        </div>
        {p.length > 0 && (
          <div
            className={
              "ml-[12px] overflow-x-auto flex items-center gap-[4px] text-[12px] leading-[22px] text-[var(--color-text-secondary)] breadcrumb-scrollbar-hide"
            }
          >
            {p.map((e, t) => (
              <span
                key={`${e}-${t}`}
                className={"flex items-center gap-[4px] whitespace-nowrap"}
              >
                {t > 0 && (
                  <ChevronDown
                    size={10}
                    className={
                      "shrink-0 -rotate-90 text-[var(--color-text-muted)]"
                    }
                  />
                )}
                <span
                  className={
                    t === p.length - 1
                      ? "text-[var(--color-text-primary)] font-medium"
                      : ""
                  }
                >
                  {e}
                </span>
              </span>
            ))}
          </div>
        )}
        <style>{`
          .breadcrumb-scrollbar-hide::-webkit-scrollbar {
            height: 2px;
          }
          .breadcrumb-scrollbar-hide::-webkit-scrollbar-track {
            background: transparent;
          }
          .breadcrumb-scrollbar-hide::-webkit-scrollbar-thumb {
            background: transparent;
            border-radius: 1px;
          }
          .breadcrumb-scrollbar-hide:hover::-webkit-scrollbar-thumb {
            background: rgba(0,0,0,0.15);
          }
        `}</style>
      </div>
      <Drawer
        open={r}
        onClose={g}
        placement={"left"}
        width={250}
        closable={false}
        mask={true}
        maskClosable={true}
        className={"lg:hidden"}
        styles={{
          body: {
            padding: 0,
            height: "100%",
            overflow: "hidden",
          },
        }}
        style={{
          padding: 0,
        }}
      >
        <div className={"bg-white flex flex-col h-full"}>
          <div className={"flex flex-col gap-[12px] p-[16px] shrink-0"}>
            <DocSearchModule.DocSearch isMobile={true} onNavigate={g} />
            <tC.A
              value={d}
              onChange={(e) => c(e)}
              className={
                "w-full [&_.ant-select-selector]:!border-[var(--color-border-warm)] [&_.ant-select-selector]:!shadow-none"
              }
              style={{
                height: 32,
                borderRadius: 6,
              }}
              suffixIcon={
                <ChevronDown
                  size={14}
                  className={"text-[var(--color-text-secondary)]"}
                />
              }
              popupClassName={"mobile-doc-nav-select-popup"}
              options={i.map((e) => ({
                value: e.key,
                label: (0, DocumentTitlesModule.getLocalizedTitle)(e, language),
              }))}
            />
            <style>{`
              .mobile-doc-nav-select-popup .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
                background-color: #F7F3EF !important;
              }
              .mobile-doc-nav-select-popup .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
                background-color: #F0EBE5 !important;
              }
            `}</style>
          </div>
          <div className={"flex-1 overflow-auto px-[16px] pb-[16px]"}>
            {u?.items && u.items.length > 0 && (
              <div className={"flex flex-col gap-px items-start w-full"}>
                {u.items.map((i) => {
                  if ("spacer" in i) return null;
                  let {
                      key: key,
                      titleZh: titleZh,
                      titleEn: titleEn,
                      href: href,
                      noLink: noLink,
                      items: items,
                      defaultCollapse: defaultCollapse,
                      agreementFullPath: agreementFullPath,
                    } = i,
                    m = (0, LocalizedPathsModule.Qe)(pathname, language),
                    h = u.href ? `${m}${u.href}` : m,
                    f = agreementFullPath
                      ? String(agreementFullPath).replace(/^\/+/u, "")
                      : "",
                    M = href ? (f ? `/docs/${f}` : `${h}${href}`) : undefined;
                  return (
                    <DocNavItemModule.DocNavItem
                      key={key}
                      titleZh={titleZh}
                      titleEn={titleEn}
                      href={M}
                      noLink={noLink}
                      items={items}
                      defaultCollapse={defaultCollapse}
                      agreementFullPath={agreementFullPath}
                      level={0}
                      isSheet={true}
                      onClose={g}
                    />
                  );
                })}
              </div>
            )}
          </div>
          <div className={"shrink-0"}>
            <div className={"pb-[24px] px-[24px]"}>
              <LanguageToggleModule.LanguageToggle />
            </div>
          </div>
        </div>
      </Drawer>
    </jsxRuntime.Fragment>
  ) : null;
});
export { DocsMobileNav };
